import React, { Component } from 'react';
import { connect } from 'react-redux';

/*Actions*/
import {
	getDocuments,
} from '../../../redux/actions';

class Training extends Component {
    constructor(props) {
		super(props);
		this.state = {
			errorMessage: '',
			trainingDocuments:{
        appliances: [
          {
            name: "Login and My Profile",
            fileName: "Login & My Profile",
            length: "5 min",
          },
          {
            name: "Availability",
            fileName: "Availability",
            length: "7 min",
          },
          {
            name: "List",
            fileName: "List",
            length: "4 min",
          },
          {
            name: "Ordering",
            fileName: "Ordering",
            length: "13 min",
          },
          {
            name: "Search & Manage Orders",
            fileName: "Search_Manage_Orders",
            length: "9 min",
          },
          {
            name: "Edit Booked Orders",
            fileName: "Editing Booked Orders",
            length: "7 min",
          },
          {
            name: "Managing Backorders",
            fileName: "Managing Backorders",
            length: "9 min",
          },
          {
            name: "Searching Serial Numbers",
            fileName: "Serial Numbers",
            length: "3 min",
          },
          {
            name: "Returns",
            fileName: "Returns",
            length: "7 min",
          },
          {
            name: "Brochures",
            fileName: "Brochures",
            length: "5 min",
          },
          {
            name: "Search & Pay Invoices",
            fileName: "Search & Pay Invoices",
            length: "7 min",
          },
          {
            name: "Packages",
            fileName: "Packages",
            length: "4 min",
          },
          {
            name: "Requesting Additional Accounts (PDF)",
            fileName: "RequestingAccounts",
            fileType: "pdf",
          },
          {
            name: "New Brochure Enhancements (PDF)",
            fileName: "NewBrochureEnhancements",
            fileType: "pdf",
          },
          {
            name: "New Manage Orders Enhancements (PDF)",
            fileName: "ManageOrders2025",
            fileType: "pdf",
          },
          {
            name: "Availability and Delivery Date Enhancements, Aug 2025 (PDF)",
            fileName: "AvailabilityandDeliveryDateEnhancements",
            fileType: "pdf",
            isNew: "new",
          }
        
        ],
  
          // , {
          //     name: 'View and Pay Invoices',
          // 	fileName: '',
          //     length: '2 min'
          // }
        parts:[
          {
            name: "Login and My Profile",
            fileName: "Login & My Profile",
            length: "5 min",
          },
          {
              name: "Parts Ordering ",
              fileName: "PNETorderFinal",
              length: "8 min",
  
            },
            {
              name: "Parts Training Guide (PDF)",
              fileName: "PartsCustomernetTrainingGuide",
              fileType: "pdf",
  
            },
            {
              name: "Requesting Additional Accounts (PDF)",
              fileName: "RequestingAccounts",
              fileType: "pdf",
  
            },
            {
              name: "Search & Pay Invoices",
              fileName: "Search & Pay Invoices",
              length: "7 min",
            }
        ]
    }
        };
    }
    getDocuments(fileName, fileType="mp4", event) {
		event && event.preventDefault();
		const self = this;
		self.setState({
			errorMessage: ''
		}, () => {
			self.props.getDocuments(`requestType=training&fileType=${fileType}&fileName=${encodeURIComponent(fileName)}`, false, response => {
				if(!response.status) {
					self.setState({
						errorMessage: 'Error occured while fetching documents.'
					});
				} else {
					window.open(response.responseObject);
				}
			});
		});
	}
    render() {
        const self = this;
		const { trainingDocuments } = self.state;
        return (
            <div>
                 <div id="trainingTableContainer" className="dataTableContainer" >
            <table id="trainingTable" className="dataTable cartTable borderTable">
              <thead>
                <tr>
                  <th>Finished Goods (Appliances, Air and Water Products)</th>
                </tr>
              </thead>
              <tbody>
                {trainingDocuments.appliances.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <a href="" onClick={self.getDocuments.bind( this, item.fileName, item.fileType )} > {item.name} </a>{" "}
                        {item.length ? `(${item.length})` : ""}{" "}
                        <span style={{ color: "red" }}>{item.isNew}</span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            <table id="trainingTable" className="dataTable cartTable borderTable" >
              <thead>
                <tr>
                  <th>Parts</th>
                </tr>
              </thead>
              <tbody>
                {trainingDocuments.parts.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <a href="" onClick={self.getDocuments.bind(this, item.fileName, item.fileType )}> {item.name} </a>{" "}
                        {item.length ? `(${item.length})` : ""}{" "}
                        <span style={{ color: "red" }}>{item.isNew}</span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>       
         </div>
        );
    }
};

const mapDispatchToProps = (dispatch) => ({
	getDocuments: (queryStringParams, willSaveToStore, callback) => dispatch(getDocuments(queryStringParams, willSaveToStore, callback)),
});

Training = connect(null, mapDispatchToProps)(Training);
export default Training;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Training/index.js